// extracted by mini-css-extract-plugin
module.exports = {"wrap":"PageHead_wrap__1m3BS","title":"PageHead_title__ozdWT","subtitle":"PageHead_subtitle__i_QjE"};